export const isLinkedinURL = (value) => {
  let str = value || '';

  if (!str.startsWith('https://') && !str.startsWith('http://')) {
    str = `https://${str}`;
  }

  try {
    const url = new URL(str);
    const match = '/in/';
    const restPath = url.pathname.split(match)[1];
    return (
      (url.protocol === 'http:' || url.protocol === 'https:') &&
      url.hostname === 'www.linkedin.com' &&
      url.pathname.startsWith(match) &&
      restPath.length > 0 &&
      (restPath.split('/').length === 1 || restPath.split('/')[1] === '')
    );
  } catch (error) {
    return false;
  }
};

// Rules
export const isURL = (value) => {
  if (typeof value === 'string' && value.length === 0) return true;

  const re =
    // eslint-disable-next-line no-useless-escape
    /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
  return re.test(value) || 'Not a valid URL.';
};

export const required = (value) =>
  !!value || value === 0 || 'This field is required.';

export const requiredMultiple = (value) =>
  (Array.isArray(value) && value.length !== 0) || 'This field is required.';

export const linkedinURL = (value) =>
  isLinkedinURL(value) || 'Not a valid Linkedin URL';

export const email = (value) => {
  if (!value) return true;

  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(value).toLowerCase()) || 'Not a valid email address';
};

export const nonAlphanumericCharactersRule = (val, allowComma, customRegex) => {
  if (!val) return true;

  const noDuplicateChars = allowComma ? /^[ .,&()-]+$/ : /^[ .&()-]+$/;
  let validNameRegex = allowComma
    ? /^[a-zA-Z0-9 .,&()-]+$/
    : /^[a-zA-Z0-9 .&()-]+$/;
  if (customRegex) {
    validNameRegex = customRegex;
  }
  for (let index = 0; index < val.length; index++) {
    const currentChar = val[index];
    const prevChar = val[index - 1];

    // Check if the first character is valid
    if (index === 0 && !validNameRegex.test(currentChar)) {
      return false;
    }

    // Check for invalid character
    if (!validNameRegex.test(currentChar)) {
      return false;
    }

    // Check for duplicate consecutive non-alphanumeric characters
    if (
      noDuplicateChars.test(currentChar) &&
      noDuplicateChars.test(prevChar) &&
      currentChar === prevChar
    ) {
      return false;
    }
  }

  return true;
};
